import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
const roundedCorners = {
    full: 'rounded-full',
    none: '',
    normal: 'rounded-md',
};
export const Skeleton = (props) => {
    const { className = '', roundedCorner = 'normal', tagName: Tag = 'div', } = props;
    return (_jsx(Tag, { className: clsx('bg-gray-200', 'opacity-10', 'animate-pulse', roundedCorners[roundedCorner], className) }));
};
